// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--spc-box-container h6,
.scl--ttgle-box-contianer h6,
.scl--sdp-box-container p,
.scl--sic-box-container h6,
.scl--sib-box-container h6 {
    margin: 0px;
    padding: 0px;
}

.scl--spc-box-container {
    width: 100%;
    min-height: 60px;
    padding-right: 11px;
    padding-left: 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(253, 253, 253, 1);
    border-radius: 4px;
    position: relative;
    outline: 1px dashed rgba(208, 213, 221, 0.3);
}

.scl--spc-box-container .border-style {
    width: 4px;
    height: 100%;
    background-color: rgba(132, 165, 120, 1);
    position: absolute;
    left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.scl--spc-box-container h6 {
    font-size: 16px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: rgba(0, 0, 0, 0.8);
}

.scl--spc-box-container .text-field-style {
    width: 219px;
    height: 31px;
}

.scl--spc-box-container .text-field-style .scl--cms-components-textFieldInline-plate {
    height: 31px;
}

.scl--ttgle-box-contianer {
    width: 100%;
    min-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.scl--ttgle-box-contianer .h6-txt {
    font-size: 14px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: var(--typography-text-body-secondary);
}

.scl--sdp-box-container {
    width: 100%;
    min-height: 120px;
    padding: 11px 11px 11px 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(253, 253, 253, 1);
    border-radius: 4px;
    position: relative;
    outline: 1px dashed rgba(208, 213, 221, 0.3);
    gap: 20px;
}

.scl--sdp-box-container .border-style {
    width: 4px;
    height: 100%;
    background-color: rgba(132, 165, 120, 1);
    position: absolute;
    left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.scl--sdp-box-container .p-text {
    width: calc(100% - 371px);
    font-size: 16px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: rgba(0, 0, 0, 0.8);

}

.scl--sdp-box-container .textarea-field-style {
    width: 351px;
    height: 83px;
}

.scl--sdp-box-container .textarea-field-style textarea {
    width: 100%;
    height: 100%;
    resize: none;
    border-radius: 3px;
    padding: 11px;
    border: none;
    border-bottom: 4px solid white;
    outline: 1px solid rgba(138, 139, 143, 1);
    transition: all 0.3s;
    background: transparent;
    font-family: var(--font-family-inter);
    color: var(--scl--cms-components-textFieldInline-text-color);
    font-size: 14px;
}

.scl--sdp-box-container .textarea-field-style textarea:hover {
    outline: 1px solid rgba(0, 0, 0, 0.8);
}

.scl--sdp-box-container .textarea-field-style textarea:focus {
    border-bottom: 3px solid rgba(35, 136, 255, 1);
    outline: 1px solid rgba(0, 0, 0, 0.8);
}

.scl--sdp-box-container .textarea-field-style textarea:disabled{
    outline: 1px solid #00000036;
    color: #00000061;
    cursor: not-allowed;
} 

.scl--sic-box-container {
    width: 100%;
    height: 75px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 20px;
    background-color: rgba(253, 253, 253, 1);
    border-radius: 4px;
    outline: 1px dashed rgba(208, 213, 221, 0.3);
}

.scl--sic-box-container .img-style {
    width: 40px;
    height: 40px;
}

.scl--sic-box-container .img-style img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.scl--sic-box-container .title-img {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.scl--sic-box-container .title-img h6 {
    font-size: 14px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: rgba(50, 53, 57, 1);
}

.scl--sic-box-container .title-img span {
    font-size: 8px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: var(--typography-text-body-secondary);
}

.scl--sib-box-container {
    width: 100%;
    height: 75px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    background-color: rgba(253, 253, 253, 1);
    border-radius: 4px;
    outline: 1px dashed rgba(208, 213, 221, 0.3);
}

.scl--sib-box-container .img-container {
    display: flex;
    gap: 20px;
    align-items: center;
}

.scl--sib-box-container .img-container .img-style {
    width: 40px;
    height: 40px;
}

.scl--sib-box-container .img-container .img-style img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.scl--sib-box-container .img-container h6 {
    font-size: 14px;
    font-family: var(--font-family-inter);
    font-weight: normal;
    color: rgba(50, 53, 57, 1);
}

.scl--sib-box-container .textfield-style {
    width: 219px;
}

.scl--sib-box-container .textfield-style .scl--cms-components-textFieldInline-plate {
    height: 31px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/preview-component.css"],"names":[],"mappings":"AAAA;;;;;IAKI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,OAAO;IACP,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,OAAO;IACP,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;;AAE7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;IAC5D,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,wCAAwC;IACxC,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,wCAAwC;IACxC,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".scl--spc-box-container h6,\n.scl--ttgle-box-contianer h6,\n.scl--sdp-box-container p,\n.scl--sic-box-container h6,\n.scl--sib-box-container h6 {\n    margin: 0px;\n    padding: 0px;\n}\n\n.scl--spc-box-container {\n    width: 100%;\n    min-height: 60px;\n    padding-right: 11px;\n    padding-left: 21px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: rgba(253, 253, 253, 1);\n    border-radius: 4px;\n    position: relative;\n    outline: 1px dashed rgba(208, 213, 221, 0.3);\n}\n\n.scl--spc-box-container .border-style {\n    width: 4px;\n    height: 100%;\n    background-color: rgba(132, 165, 120, 1);\n    position: absolute;\n    left: 0;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.scl--spc-box-container h6 {\n    font-size: 16px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: rgba(0, 0, 0, 0.8);\n}\n\n.scl--spc-box-container .text-field-style {\n    width: 219px;\n    height: 31px;\n}\n\n.scl--spc-box-container .text-field-style .scl--cms-components-textFieldInline-plate {\n    height: 31px;\n}\n\n.scl--ttgle-box-contianer {\n    width: 100%;\n    min-height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.scl--ttgle-box-contianer .h6-txt {\n    font-size: 14px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: var(--typography-text-body-secondary);\n}\n\n.scl--sdp-box-container {\n    width: 100%;\n    min-height: 120px;\n    padding: 11px 11px 11px 21px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: rgba(253, 253, 253, 1);\n    border-radius: 4px;\n    position: relative;\n    outline: 1px dashed rgba(208, 213, 221, 0.3);\n    gap: 20px;\n}\n\n.scl--sdp-box-container .border-style {\n    width: 4px;\n    height: 100%;\n    background-color: rgba(132, 165, 120, 1);\n    position: absolute;\n    left: 0;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.scl--sdp-box-container .p-text {\n    width: calc(100% - 371px);\n    font-size: 16px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: rgba(0, 0, 0, 0.8);\n\n}\n\n.scl--sdp-box-container .textarea-field-style {\n    width: 351px;\n    height: 83px;\n}\n\n.scl--sdp-box-container .textarea-field-style textarea {\n    width: 100%;\n    height: 100%;\n    resize: none;\n    border-radius: 3px;\n    padding: 11px;\n    border: none;\n    border-bottom: 4px solid white;\n    outline: 1px solid rgba(138, 139, 143, 1);\n    transition: all 0.3s;\n    background: transparent;\n    font-family: var(--font-family-inter);\n    color: var(--scl--cms-components-textFieldInline-text-color);\n    font-size: 14px;\n}\n\n.scl--sdp-box-container .textarea-field-style textarea:hover {\n    outline: 1px solid rgba(0, 0, 0, 0.8);\n}\n\n.scl--sdp-box-container .textarea-field-style textarea:focus {\n    border-bottom: 3px solid rgba(35, 136, 255, 1);\n    outline: 1px solid rgba(0, 0, 0, 0.8);\n}\n\n.scl--sdp-box-container .textarea-field-style textarea:disabled{\n    outline: 1px solid #00000036;\n    color: #00000061;\n    cursor: not-allowed;\n} \n\n.scl--sic-box-container {\n    width: 100%;\n    height: 75px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    background-color: rgba(253, 253, 253, 1);\n    border-radius: 4px;\n    outline: 1px dashed rgba(208, 213, 221, 0.3);\n}\n\n.scl--sic-box-container .img-style {\n    width: 40px;\n    height: 40px;\n}\n\n.scl--sic-box-container .img-style img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.scl--sic-box-container .title-img {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.scl--sic-box-container .title-img h6 {\n    font-size: 14px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: rgba(50, 53, 57, 1);\n}\n\n.scl--sic-box-container .title-img span {\n    font-size: 8px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: var(--typography-text-body-secondary);\n}\n\n.scl--sib-box-container {\n    width: 100%;\n    height: 75px;\n    padding: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    background-color: rgba(253, 253, 253, 1);\n    border-radius: 4px;\n    outline: 1px dashed rgba(208, 213, 221, 0.3);\n}\n\n.scl--sib-box-container .img-container {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n}\n\n.scl--sib-box-container .img-container .img-style {\n    width: 40px;\n    height: 40px;\n}\n\n.scl--sib-box-container .img-container .img-style img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.scl--sib-box-container .img-container h6 {\n    font-size: 14px;\n    font-family: var(--font-family-inter);\n    font-weight: normal;\n    color: rgba(50, 53, 57, 1);\n}\n\n.scl--sib-box-container .textfield-style {\n    width: 219px;\n}\n\n.scl--sib-box-container .textfield-style .scl--cms-components-textFieldInline-plate {\n    height: 31px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
